// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Inter-Regular400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../fonts/Inter-Medium500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../fonts/Inter-SemiBold600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../fonts/Inter-Bold700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
.InputNumber_icon__brovi {
  position: absolute;
  left: 15px;
  top: 14px;
  height: 18px;
  z-index: 6;
}

.InputNumber_input__5wbcD {
  border-radius: 12px !important;
  width: 100% !important;
  height: 44px;
  padding: 14px 17px 14px 42px !important;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  transition: 0.3ms;
  box-sizing: border-box;
  padding: 0 !important;
}
.InputNumber_input__5wbcD .rs-input-group-btn {
  background: none;
  font-size: 26px;
}
.InputNumber_input__5wbcD .rs-input-number {
  background: none;
}
.InputNumber_input__5wbcD .rs-input {
  background: none;
}
.InputNumber_input_container__NpHKq {
  position: relative;
}
.InputNumber_input_default__eVubl {
  background-color: #F3F3F4 !important;
  border: none !important;
  color: #758282 !important;
  -webkit-box-shadow: inset 0 0 0 50px #F3F3F4;
  -webkit-text-fill-color: #758282;
}
.InputNumber_input_default__eVubl:hover {
  background-color: #F3FFFF !important;
  border: 1px solid #31C9CA !important;
  color: #616E6E !important;
  -webkit-box-shadow: inset 0 0 0 50px #F3FFFF !important;
  -webkit-text-fill-color: #616E6E;
}
.InputNumber_input_active__7mUn0 {
  border: 1px solid #ffa368 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff;
}
.InputNumber_input_error__n4Vo2 {
  border: 1px solid #FF5756 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff;
  margin-bottom: 0 !important;
}
.InputNumber_input_valid__xKr0U {
  border: 1px solid #1DB5B6 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/vendors/fonts.scss","webpack://./src/components/UI/Input/InputNumber.module.scss","webpack://./src/styles/vendors/mixins.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACFF;AAxBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AA0BF;;AAvBA;ECVE,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,uCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EDEA,qBAAA;AAoCF;AAnCE;EACE,gBAAA;EACA,eAAA;AAqCJ;AAnCE;EACE,gBAAA;AAqCJ;AAnCE;EACE,gBAAA;AAqCJ;AAlCE;EACE,kBAAA;AAoCJ;AAjCE;ECdA,oCAAA;EACA,uBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;ADkDF;AArCI;ECTF,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,uDAAA;EACA,gCAAA;ADiDF;AAvCE;ECNA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,4CAAA;ADgDF;AAzCE;ECHA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,4CAAA;EACA,2BAAA;AD+CF;AA5CE;ECCA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,uDAAA;AD8CF","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Regular400.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Medium500.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-SemiBold600.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Bold700.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}","@import \"../../../styles/vendors/mixins\";\n@import \"../../../styles/vendors/fonts\";\n\n.icon {\n  position: absolute;\n  left: 15px;\n  top: 14px;\n  height: 18px;\n  z-index: 6;\n}\n\n.input {\n  @include input;\n  padding: 0 !important;\n  :global(.rs-input-group-btn){\n    background: none;\n    font-size: 26px;\n  }\n  :global(.rs-input-number){\n    background: none;\n  }\n  :global(.rs-input){\n    background: none;\n  }\n\n  &_container {\n    position: relative;\n  }\n\n  &_default {\n    @include input_default;\n\n    &:hover {\n      @include input_hover;\n    }\n  }\n\n  &_active {\n    @include input_active;\n  }\n\n  &_error {\n    @include input_error;\n  }\n\n  &_valid {\n    @include input_valid;\n  }\n}\n","@mixin input {\n  border-radius: 12px !important;\n  width: 100% !important;\n  height: 44px;\n  padding: 14px 17px 14px 42px !important;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  transition: 0.3ms;\n  box-sizing: border-box;\n}\n\n@mixin input_default {\n  background-color: #F3F3F4 !important;\n  border: none !important;\n  color: #758282 !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3F3F4;\n  -webkit-text-fill-color: #758282;\n}\n\n@mixin input_hover {\n  background-color: #F3FFFF !important;\n  border: 1px solid #31C9CA !important;\n  color: #616E6E !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3FFFF !important;\n  -webkit-text-fill-color: #616E6E;\n}\n\n@mixin input_active {\n  border: 1px solid #ffa368 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n}\n\n@mixin input_error {\n  border: 1px solid #FF5756 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n  margin-bottom: 0 !important;\n}\n\n@mixin input_valid {\n  border: 1px solid #1DB5B6 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `InputNumber_icon__brovi`,
	"input": `InputNumber_input__5wbcD`,
	"input_container": `InputNumber_input_container__NpHKq`,
	"input_default": `InputNumber_input_default__eVubl`,
	"input_active": `InputNumber_input_active__7mUn0`,
	"input_error": `InputNumber_input_error__n4Vo2`,
	"input_valid": `InputNumber_input_valid__xKr0U`
};
export default ___CSS_LOADER_EXPORT___;
